import moment from 'moment-timezone'

export const formatDatePMB = (val, val2) => {
  return (
    <div className="d-flex flex-column">
      <span> {moment(val).locale('id').format('Do MMM YYYY')}</span>
      <span className="text-muted">
        {moment(val2 ?? val)
          .locale('id')
          .format('HH:mm')}
      </span>
    </div>
  )
}

export const formatDatePMBV2 = (val) => {
  return moment(val).locale('id').format('Do MMM YYYY, HH:mm')
}

export const formatDateOnlyPMB = (val) => {
  return moment(val).locale('id').format('Do MMM YYYY')
}

export const formatMonthYearOnly = (val) => {
  return moment(val).locale('id').format('MMM YYYY')
}

export const formatDateOnlyPMBV1 = (val) => {
  return moment(val).locale('id').format('Do MMMM YYYY')
}

export const formatTimeOnlyPMB = (val) => {
  return moment(val).locale('id').format('HH:mm')
}

export const formatDuration = (seconds) => {
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  if (days > 0) {
    return `${days} hari${hours > 0 ? ` ${hours} jam` : ''}`
  } else if (hours > 0) {
    return `${hours} jam${minutes > 0 ? ` ${minutes} menit` : ''}`
  } else if (minutes > 0) {
    return `${minutes} menit`
  } else {
    return `${remainingSeconds} detik`
  }
}
